import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import App from "./App";
import "./index.css";

const manifestUrl = "https://sidebets.vercel.app/tonconnect-manifest.json";

const botUsername = import.meta.env.VITE_BOT_USERNAME || "sidebets_dev_bot";
const twaReturnUrl = `https://t.me/${botUsername}/app` as `${string}://${string}`;

// Flag: try TonConnect, skip if it crashes during init.
// TonConnect UI appends a widget to document.body in its constructor;
// this throws in some Telegram WebView contexts (inline button launches).
let tonConnectAvailable = true;
try {
  // Probe: TonConnect will run `document.body.appendChild()` inside
  // its constructor called from TonConnectUIProvider's useState init.
  // If body isn't writable, we skip TonConnect entirely.
  const probe = document.createElement("div");
  document.body.appendChild(probe);
  document.body.removeChild(probe);
} catch {
  tonConnectAvailable = false;
}

function Root() {
  if (!tonConnectAvailable) {
    return (
      <BrowserRouter>
        <App />
      </BrowserRouter>
    );
  }

  return (
    <TonConnectUIProvider
      manifestUrl={manifestUrl}
      actionsConfiguration={{ twaReturnUrl }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </TonConnectUIProvider>
  );
}

function mount() {
  const root = document.getElementById("root");
  if (!root) {
    setTimeout(mount, 50);
    return;
  }
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <Root />
    </React.StrictMode>
  );
}
mount();
